<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I’d like to return my book</h1>

			<p v-if="!loading && !is_ia_item">
				You can return your book by <a class="help-link" href="/returns">clicking on the link</a> and starting the return procedure.
			</p>

			<p v-if="!loading && is_ia_item">
				This item is an {{ inclusive_access_name }} item, and cannot be returned. If you drop the course within the add drop period, you will be refunded for it as part of your tuition refund.
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import Axios from 'axios';
	import BaseNavLinks from './../../../components/BaseNavLinks';

	export default {
		name: "ConfirmReturn",

		components: {
			BaseNavLinks
		},

		computed: {
			inclusive_access_name() {
				return this.$globs.institute_info.inclusive_access_name;
			},
		},

		data() {
			return {
				is_ia_item: false,
				loading: false
			};
		},

		mounted() {
			const self = this;
			self.loading = true;

			self.order_line_id = parseInt(self.$route.params.id);

			Axios.get('/service/customer_help/rest/index.php/customer_help/check_if_ia_item/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data) {
						if (
							!_.isUndefined(response['data']['data']['is_inclusive_access_item'])
							&& response['data']['data']['is_inclusive_access_item'] == true
						) {
							self.is_ia_item = true;
						}
					}
				})
				.finally(function () {
					self.loading = false;
				});
		}
	}
</script>

<style scoped lang="less">
	.h-email-form {
		margin-top: 20px;
	}
</style>